import { SubmitHandler, useForm, Controller } from "react-hook-form"
import { toast } from "react-toastify"
import { useNavigate, useParams } from "react-router-dom"
import ButtonWithIcon from "components/ui/button/ButtonWithIcon"
import TextInput from "components/ui/form/TextInput"
import { useMutationCreateChoiceQuestion } from "utils/api/cms/mutations/hooks"
import { GeneralChoiceQuestionRequest } from "utils/api/cms/types"
import {
    BookmarkIcon,
    ExclamationTriangleIcon,
} from "@heroicons/react/24/solid"
import SelectInput from "components/ui/form/SelectInput"

const TYPE_OPTIONS = [
    {
        label: "Benar",
        value: true,
    },
    {
        label: "Salah",
        value: false,
    }
]
const ChoiceForm = (props) => {
    const navigate = useNavigate()
    const params = useParams()
    const {
        handleSubmit,
        control,
        register,
        formState: { errors, isSubmitting },
    } = useForm<GeneralChoiceQuestionRequest>({})
    const { mutate: mutateCreate } =
        useMutationCreateChoiceQuestion({
            onSuccess(data) {
                if (!data.success) {
                    return
                }
                toast.success("pertanyaan berhasil dibuat")
                setTimeout(() => {
                    navigate("/cms/course/category-question/" + Number(props.segments[2]) +'/'+ props.segments[3] +'/'+ props.segments[4] +'/'+ props.segments[5])
                }, 1000)
            },
            onError(error) {
                toast.error(error.message)
            },
        })
    // console.log(props.segments);

    const onSubmit: SubmitHandler<GeneralChoiceQuestionRequest> = (data) => {
        let payload: GeneralChoiceQuestionRequest = {
            question_id: Number(params.id),
            name: data.name,
            is_true: data.is_true ? Boolean(data.is_true.valueOf) : false,
        };
        return mutateCreate(payload);
    }

    return (
        <form
            onSubmit={handleSubmit(onSubmit)}
            className="flex flex-col gap-4 pb-4 min-w-[42rem]"
        >
            <TextInput
                type="text"
                className="cms-base-input mt-2"
                labelClass="cms-base-label mt-4"
                isRequired
                label="Jawaban"
                errorMessage={errors.name?.message}
                errorIcon={
                    <ExclamationTriangleIcon
                        height={24}
                        width={24}
                        className="text-red-800"
                    />
                }
                {...register("name", {
                    required: {
                        value: true,
                        message: "Jawaban wajib diisi",
                    },
                })}
            />
            <div className="sm:col-span-2">
                <Controller
                    control={control}
                    name="is_true"
                    rules={{
                        required: { value: true, message: "Status Jawaban" },
                    }}
                    render={({ field }) => (
                        <SelectInput
                            {...field}
                            label="Status Jawaban"
                            labelClass="cms-base-label"
                            errorMessage={errors.is_true?.message}
                            errorIcon={
                                <ExclamationTriangleIcon
                                    height={24}
                                    width={24}
                                    className="text-red-800"
                                />
                            }
                            classNames={{
                                container: () => "max-w-2xl",
                            }}
                            options={TYPE_OPTIONS}
                            isRequired
                        />
                    )}
                />
            </div>
            <ButtonWithIcon
                action={undefined}
                type="submit"
                class="self-start mt-12 border-2 border-transparent bg-primary text-white space-x-2 hover:bg-transparent hover:text-white hover:border-primary"
                disabled={isSubmitting}
            >
                <BookmarkIcon className="h-6 w-6 text-white" />
                <span>
                    {!isSubmitting ? (
                        <>{"Tambahkan"}</>
                    ) : (
                        "Menyimpan..."
                    )}
                </span>
            </ButtonWithIcon>
        </form>
    )
}

export default ChoiceForm
